<div class="container">

  <header class="page-heading">
    <h1>STP Calculator</h1>
    <p>Calculate returns from a Systematic Transfer Plan (STP) between mutual funds with this online STP calculator.</p>
  </header>

  <div class="card mb-lg">
    <div class="section-title">STP Details</div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('sourceLumpsum')">
        <label class="field-label" for="sourceLumpsum">Source Fund Lumpsum</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="sourceLumpsum" type="number"
            [(ngModel)]="sourceLumpsum"
            [min]="C.sourceLumpsum.min" [max]="C.sourceLumpsum.max" [step]="C.sourceLumpsum.step"
            (ngModelChange)="onFieldChange('sourceLumpsum')"
            (blur)="onFieldBlur('sourceLumpsum')"
            placeholder="e.g. 10,00,000"
            autocomplete="off"/>
        </div>
        @if (hasError('sourceLumpsum')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('sourceLumpsum') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('monthlyTransfer')">
        <label class="field-label" for="monthlyTransfer">Monthly Transfer Amount</label>
        <div class="input-shell prefix">
          <span class="affix">₹</span>
          <input id="monthlyTransfer" type="number"
            [(ngModel)]="monthlyTransfer"
            [min]="C.monthlyTransfer.min" [max]="C.monthlyTransfer.max" [step]="C.monthlyTransfer.step"
            (ngModelChange)="onFieldChange('monthlyTransfer')"
            (blur)="onFieldBlur('monthlyTransfer')"
            placeholder="e.g. 25,000"
            autocomplete="off"/>
        </div>
        @if (hasError('monthlyTransfer')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('monthlyTransfer') }}
          </div>
        }
      </div>
    </div>

    <div class="field-row-2">
      <div class="field-group" [class.has-error]="hasError('sourceRate')">
        <label class="field-label" for="sourceRate">Source Fund Return</label>
        <div class="input-shell suffix">
          <input id="sourceRate" type="number"
            [(ngModel)]="sourceRate"
            [min]="C.sourceRate.min" [max]="C.sourceRate.max" [step]="C.sourceRate.step"
            (ngModelChange)="onFieldChange('sourceRate')"
            (blur)="onFieldBlur('sourceRate')"
            placeholder="e.g. 6.5"
            autocomplete="off"/>
          <span class="affix right">%</span>
        </div>
        <div class="field-hint">Typically a low-volatility debt/liquid fund</div>
        @if (hasError('sourceRate')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('sourceRate') }}
          </div>
        }
      </div>

      <div class="field-group" [class.has-error]="hasError('destRate')">
        <label class="field-label" for="destRate">Destination Fund Return</label>
        <div class="input-shell suffix">
          <input id="destRate" type="number"
            [(ngModel)]="destRate"
            [min]="C.destRate.min" [max]="C.destRate.max" [step]="C.destRate.step"
            (ngModelChange)="onFieldChange('destRate')"
            (blur)="onFieldBlur('destRate')"
            placeholder="e.g. 12"
            autocomplete="off"/>
          <span class="affix right">%</span>
        </div>
        <div class="field-hint">Typically an equity fund</div>
        @if (hasError('destRate')) {
          <div class="field-error">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            {{ fieldError('destRate') }}
          </div>
        }
      </div>
    </div>

    <div class="field-group" [class.has-error]="hasError('tenureYears')">
      <label class="field-label" for="tenureYears">Transfer Duration</label>
      <div class="input-shell suffix">
        <input id="tenureYears" type="number"
          [(ngModel)]="tenureYears"
          [min]="C.tenureYears.min" [max]="C.tenureYears.max" [step]="C.tenureYears.step"
          (ngModelChange)="onFieldChange('tenureYears')"
          (blur)="onFieldBlur('tenureYears')"
          placeholder="e.g. 3"
          autocomplete="off"/>
        <span class="affix right">Yr</span>
      </div>
      @if (hasError('tenureYears')) {
        <div class="field-error">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          {{ fieldError('tenureYears') }}
        </div>
      }
    </div>

    <div class="action-row">
      <button type="button" class="btn btn-primary" (click)="calculate()" [class.btn-disabled]="showFormErrors && !isFormValid">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        Calculate
      </button>
      @if (calculated) {
        <button type="button" class="btn btn-secondary" (click)="reset()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
          Reset
        </button>
      }
      @if (showFormErrors && !isFormValid) {
        <span class="form-error-hint">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Fix the errors above to calculate
        </span>
      }
    </div>
  </div>

  @if (calculated && result) {
    @if (result.finalSourceValue <= 0.5 && result.months.length < tenureYears * 12) {
      <div class="savings-banner mb-md">
        <div class="sb-item">
          <div class="sb-val">Month {{ result.months.length }}</div>
          <div class="sb-lbl">Source Fund Fully Transferred</div>
        </div>
      </div>
    }

    <div class="summary-grid mb-md">
      <div class="summary-card c-blue">
        <div class="sc-icon"></div>
        <div class="sc-label">Total Transferred</div>
        <div class="sc-value">{{ fmt.currency(result.totalTransferred) }}</div>
      </div>
      <div class="summary-card c-green">
        <div class="sc-icon"></div>
        <div class="sc-label">Destination Fund Value</div>
        <div class="sc-value">{{ fmt.currency(result.finalDestValue) }}</div>
        <div class="sc-sub sc-save">↑ Gain {{ fmt.currency(result.destGain) }}</div>
      </div>
      <div class="summary-card c-red">
        <div class="sc-icon"></div>
        <div class="sc-label">Remaining in Source</div>
        <div class="sc-value">{{ fmt.currency(result.finalSourceValue) }}</div>
      </div>
      <div class="summary-card c-blue">
        <div class="sc-icon"></div>
        <div class="sc-label">Combined Value</div>
        <div class="sc-value">{{ fmt.currency(result.combinedValue) }}</div>
      </div>
    </div>

    <div class="card charts-card mb-md">
      <div class="section-title">Visual Breakdown</div>
      <div class="charts-top-row">
        <div class="chart-panel">
          <div class="chart-panel-label">Value Composition</div>
          <div class="chart-canvas-wrap chart-canvas-pie">
            <canvas #breakdownRef></canvas>
          </div>
        </div>
        <div class="chart-panel chart-panel-bar">
          <div class="chart-panel-label">Fund Balances Over Time</div>
          <div class="chart-canvas-wrap">
            <canvas #growthRef></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-md">
      <div class="section-title">Transfer Schedule</div>

      <div class="tab-bar">
        <button type="button" class="tab-btn" [class.active]="activeTab==='yearly'" (click)="activeTab='yearly'">
          Yearly Summary
        </button>
        <button type="button" class="tab-btn" [class.active]="activeTab==='monthly'" (click)="activeTab='monthly'">
          Full Monthly Schedule
        </button>
        <div class="tab-count">
          @if (activeTab === 'yearly') { {{ result.years.length }} years }
          @else { {{ result.months.length }} months }
        </div>
      </div>

      @if (activeTab === 'yearly') {
        <div class="tbl-wrap">
          <table>
            <thead>
              <tr>
                <th class="t-left">Year</th>
                <th class="t-prepay">Transferred</th>
                <th>Source Balance</th>
                <th class="t-balance">Destination Balance</th>
              </tr>
            </thead>
            <tbody>
              @for (row of result.years; track row.year) {
                <tr>
                  <td class="t-left t-year">Year {{ row.year }}</td>
                  <td class="t-prepay">{{ fmt.currency(row.transferredThisYear) }}</td>
                  <td>{{ fmt.currency(row.sourceBalance) }}</td>
                  <td class="t-balance">{{ fmt.currency(row.destBalance) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (activeTab === 'monthly') {
        <div class="tbl-wrap">
          <table>
            <thead>
              <tr>
                <th class="t-left">#</th>
                <th class="t-prepay">Transferred</th>
                <th>Source Balance</th>
                <th class="t-balance">Destination Balance</th>
              </tr>
            </thead>
            <tbody>
              @for (row of result.months; track row.month) {
                <tr>
                  <td class="t-left t-num">Month {{ row.month }}</td>
                  <td class="t-prepay">{{ fmt.currency(row.transferred) }}</td>
                  <td>{{ fmt.currency(row.sourceBalance) }}</td>
                  <td class="t-balance">{{ fmt.currency(row.destBalance) }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
</div>

<!-- ══ SEO CONTENT ══════════════════════════════════════════════════════ -->
<section class="container seo-content">
  <div class="card">
    <h2 class="section-title">How is STP Return Calculated?</h2>
    <p>
      A Systematic Transfer Plan (STP) moves a fixed amount every month from a source fund
      (typically a low-volatility debt/liquid fund) into a destination fund (typically equity).
      Each month, both funds earn their own return, and the transfer amount moves from source to
      destination — similar to running an SIP funded from an existing lumpsum instead of fresh cash.
    </p>
    <p>
      The transfer schedule stops early if the source fund is fully depleted before your chosen
      duration ends. Use the calculator above to see exactly how your money moves between the two
      funds each month.
    </p>

    <h2 class="section-title mt-sm">Frequently Asked Questions</h2>
    <div class="faq-item">
      <h3>Why use an STP instead of investing a lumpsum directly?</h3>
      <p>
        An STP spreads your equity entry over time instead of investing the entire lumpsum at once,
        reducing the risk of investing everything right before a market downturn — while the
        uninvested portion continues earning returns in the source fund.
      </p>
    </div>
    <div class="faq-item">
      <h3>What happens if the source fund runs out before my chosen duration?</h3>
      <p>
        The transfers simply stop once the source fund balance reaches zero — the destination fund
        continues to hold and grow whatever has already been transferred into it.
      </p>
    </div>
    <p class="learn-crosslink">
      Read more: <a routerLink="/learn/stp-explained">STP explained: moving from lump sum to equity safely</a>
    </p>
  </div>
</section>
